import { GetAyahProps, GetWordsProps } from '@app-types/KuranTypes'
import { Fragment } from 'react'
import { getSurahAnchorId } from 'helpers/surahAnchor'
import AyahComponent from './AyahComponent'
import Separator from './Separator'

export const getSpacer = (i: number) => {
  return (
    <div key={i} className="no-height m-auto h-0">
      {' '}
      &nbsp;{' '}
    </div>
  )
}

export const getAyahWords = ({
  word,
  ayahs,
  ayah,
  hideMeal,
  ayahNo,
  hideTooltip,
  mealSource,
  i,
}: GetWordsProps) => {
  if (word.type === 'ayah') {
    if (word.arapca) {
      return <AyahComponent key={i} {...{ i, ayahNo, word, hideMeal, hideTooltip }} />
    } else {
      return getSpacer(i)
    }
  }

  if (word.type === 'separator') {
    return (
      <Separator key={i} {...{ i, ayah, ayahNo, word, ayahs, hideTooltip, mealSource }} />
    )
  }

  // Surah header; its id lets surah links scroll straight to it.
  if (word.type === 'num') {
    return (
      <Fragment key={i}>
        <div
          id={getSurahAnchorId(ayah.surah.id)}
          className={`scroll-mt-32 ayah-arabic mt-4 w-full whitespace-pre-line rounded-sm bg-slate-100 p-4 px-1 py-3 dark:bg-slate-700`}
        >
          {' '}
          {word.ayahNum?.trim()}{' '}
        </div>
        <div className="ayah-arabic w-full py-2">﷽</div>
      </Fragment>
    )
  }
}

export const getOneAyah = ({
  ayah,
  hideMeal,
  ayahs,
  ayahNo,
  hideTooltip,
  mealSource,
}: GetAyahProps) =>
  ayah.words.map((word, i) =>
    getAyahWords({ word, ayah, ayahs, ayahNo, hideMeal, i, hideTooltip, mealSource }),
  )

export const reciters = [
  {
    identifier: 'Alafasy',
    englishName: 'Mishary Al-Afasy',
    name: 'مشاري العفاسي',
  },
  {
    identifier: 'AbdulBaset/Murattal',
    englishName: 'AbdulBaset (Murattal)',
    name: 'عبدالباسط عبدالصمد',
  },
  {
    identifier: 'AbdulBaset/Mujawwad',
    englishName: 'AbdulBaset (Mujawwad)',
    name: 'عبدالباسط عبدالصمد',
  },
  {
    identifier: 'Sudais',
    englishName: 'Abdurrahmaan As-Sudais',
    name: 'عبدالرحمن السديس',
  },
  {
    identifier: 'Shuraym',
    englishName: 'Saud Ash-Shuraym',
    name: 'سعود الشريم',
  },
  {
    identifier: 'Shatri',
    englishName: 'Abu Bakr Ash-Shaatree',
    name: 'أبو بكر الشاطري',
  },
  {
    identifier: 'Minshawi/Murattal',
    englishName: 'Minshawi (Murattal)',
    name: 'محمد صديق المنشاوي',
  },
  {
    identifier: 'Minshawi/Mujawwad',
    englishName: 'Minshawi (Mujawwad)',
    name: 'محمد صديق المنشاوي',
  },
  {
    identifier: 'Rifai',
    englishName: 'Hani Ar-Rifai',
    name: 'هاني الرفاعي',
  },
]
